import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { SectionLabel } from './ui/SectionLabel';
import { TOMOS, TOMO_INCLUYE } from '../data/content';
export function Tomos() {
  return <section id="tomos" className="w-full bg-ink px-5 py-16 sm:px-8 sm:py-24" data-id="element-182" data-mp="1h3w17n5x8kfb">
      <div className="mx-auto max-w-6xl" data-id="element-183" data-mp="1cc4752nk3wkf">
        <div className="max-w-3xl" data-id="element-184" data-mp="1cb2wv0ed7e3r">
          <SectionLabel data-id="element-185" data-mp="1r10esylpb7ki">6 Tomos — el protocolo completo</SectionLabel>
          <h2 className="mt-4 font-display text-3xl font-extrabold leading-tight text-white sm:text-5xl" data-id="element-186" data-mp="1r3d2zti1ye60">
            🔮 Protocolo de Desintoxicación Vincular
          </h2>
          <p className="mt-4 text-base text-violeta-100/75" data-id="element-187" data-mp="201f0hz2kuooj">
            Cada tomo es una fase. Cada fase tiene herramientas listas para aplicar hoy.
          </p>
        </div>

        <ol className="mt-12 grid gap-5 md:grid-cols-2" data-id="element-188" data-mp="5n5snxe0zgij">
          {TOMOS.map((tomo, index) => <motion.li key={tomo.numero} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.45,
          delay: index % 2 * 0.08,
          ease: 'easeOut'
        }} className="rounded-3xl border border-ink-line bg-ink-card p-6 sm:p-7" data-id="element-189" data-mp="1ndpk07ei2kk" data-mpi={index}>
              <div className="flex items-baseline gap-3" data-id="element-190" data-mp="3jfw0jidcylmr">
                <span className="font-display text-3xl font-extrabold text-violeta-600/70" data-id="element-191" data-mp="3jhfm9ohs9ovx">
                  {tomo.numero}
                </span>
                <span className="font-display text-[10px] font-semibold uppercase tracking-[0.28em] text-violeta-300" data-id="element-192" data-mp="3sf9f2pgca0ec">
                  {tomo.tomo}
                </span>
              </div>
              <h3 className="mt-3 font-display text-2xl font-bold text-white" data-id="element-193" data-mp="69ci609t7pfr">{tomo.titulo}</h3>
              <p className="mt-3 text-sm leading-relaxed text-violeta-100/75" data-id="element-194" data-mp="2325yeh5su7fr">
                {tomo.descripcion}
              </p>
              <ul className="mt-5 flex flex-wrap gap-2" data-id="element-195" data-mp="280z961tpbkc8">
                {tomo.tags.map(tag => <li key={tag} className="rounded-full bg-violeta-600/15 px-3 py-1.5 text-[11px] font-semibold text-violeta-200" data-id="element-196" data-mp="2001fmacgy59w">
                    {tag}
                  </li>)}
              </ul>
            </motion.li>)}
        </ol>

        <div className="mt-10 rounded-3xl border border-ink-line bg-ink-soft p-6 sm:p-7" data-id="element-197" data-mp="25178c864psjf">
          <p className="font-display text-[10px] font-semibold uppercase tracking-[0.28em] text-violeta-300" data-id="element-198" data-mp="2iwj2oegdhgzt">
            Cada tomo incluye
          </p>
          <ul className="mt-4 flex flex-wrap gap-x-6 gap-y-3" data-id="element-199" data-mp="2sndq3m5cummu">
            {TOMO_INCLUYE.map(item => <li key={item} className="flex items-center gap-2 text-sm text-violeta-100" data-id="element-200" data-mp="2nqnbl3977z3j">
                <CheckIcon className="h-4 w-4 text-violeta-400" aria-hidden="true" data-id="element-201" data-mp="32no5ndev4656" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}